/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { useHistory } from "react-router-dom";
import dompurify from "dompurify";

import styles from "./PageLanding.module.scss";
import cx from "classnames";
import { adobeClickTracking } from "../../../../helpers/tracking";
import { useSelector } from "react-redux";

const PageLanding = ({ boxesArr, goToPage, trackingTitle }) => {
  const { type } = useSelector((state) => state?.singleGroup);
  const history = useHistory();
  const sanitizer = dompurify.sanitize;
  const gamesType = type === "single" ? "Single Game" : "Group";
  const prop13 = `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: ${trackingTitle}`;

  const landingBox = (box) => (
    <>
      <div className={styles.left}>
        <img
          src={require(`../../../../assets/images/${box.img}`)}
          className={styles.img}
          alt=""
        />
      </div>
      <div className={styles.right}>
        <div className={styles.name}>
          <h3 dangerouslySetInnerHTML={{ __html: sanitizer(box?.boxName) }} />
          <div className={styles.extraText1}>
            {box.extraText1 && <p>{box.extraText1}</p>}
          </div>
          <div className={styles.extraText2}>
            {box.extraText2 && <p>{box.extraText2}</p>}
          </div>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 27 27"
          className={styles.arrow}
        >
          <path
            fill="#BA0C2F"
            d="M.5 23.25a3.25 3.25 0 0 0 3.25 3.25h19.5a3.25 3.25 0 0 0 3.25-3.25V3.75A3.25 3.25 0 0 0 23.25.5H3.75A3.25 3.25 0 0 0 .5 3.75v19.5Zm7.313-10.563h9.413L13.737 9.2a.814.814 0 0 1 1.15-1.15l4.876 4.875a.815.815 0 0 1 0 1.15l-4.875 4.875a.814.814 0 0 1-1.15-1.15l3.488-3.488H7.813a.812.812 0 1 1 0-1.624Z"
          />
        </svg>
      </div>
    </>
  );

  return (
    <div className={styles.boxes}>
      {boxesArr.map((box) => (
        <div
          className={cx(styles.box, box.featured ? styles.featured : null)}
          key={box.id}
          onClick={() => {
            adobeClickTracking({
              prop13,
              prop14: `${gamesType} Tickets: ${trackingTitle}: ${box.title} Click`,
            });
            history.push(`/ticket-single-group/${goToPage}`, {
              data: box.title,
            });
          }}
        >
          {landingBox(box)}
        </div>
      ))}
    </div>
  );
};

export default PageLanding;
